
    import Vue from 'vue';
    import axios from "axios";
    import { required } from "vee-validate/dist/rules";
    import { extend } from "vee-validate";
    import { ConsultClaim } from '../../../types/Sapphire_dto';
    
    

    extend("required", {
        ...required,
        message: "This field is required"
    });
    interface ConsultClaimPopup {
        PaidText: string;
    }
    const ConsultClaimPopup = Vue.extend({
        
        name: "consult-claim-popup",
        props: {
            thisEvent: Object,
        },
        data: function () {
            return {
                openPopup: false,
                title: '',
                StatusList: [
                { Key: 'Paid', Value: 'Paid' },
                { Key: 'Unpaid', Value: 'Unpaid' },
                { Key: 'Denied', Value: 'Denied' },
                // Add more options as needed
                ],
                FacList: [],
                selectedUser: new Object(),
                selectedStatus: null,
                selectedFac: null,
                selectedInsurance: null,
                ServiceToDate: new Date(),
                ServiceFromDate: new Date(),
                ProviderText: '',
                ClaimNumberText: '',
                ProcedureCodeText: '',
                DRGText: '',
                AllowedAmountText: '',
                InsurancePaymentText: '',
                PTRespText: '',
                ClaimAmountText: '',
                ContractualAdjustmentText: '',
                ClaimReceivedText: new Date(),
                ClaimAdjudicatedText: '',
                CarrierText: '',
                MemberID: '',
                GroupID: '',
                InsuranceTypeList: [
                { Key: 'State', Value: 'State' },
                { Key: 'Federal', Value: 'Federal' },
                { Key: 'Commercial', Value: 'Commercial' },
                // Add more options as needed
                ],
                PaidText: '',
                consultClaim: new Object() as ConsultClaim,
                returnClaim: new Object() as ConsultClaim,
                consultClaims: [],
                errorMessages: [],
                errorsFound: false,
                index: 0,
                disableLeftTab: false,
                disableRightTab: false,
                showDelete: true,
                disableDelete: true,
                disablePrint: true,
                disableFooterbtn: false,
                showOverlay: false,
                MedicaidChecked: false,
                PaidDate: null,
            };
        },
        mounted: function () {
            //mounted is an event in the lifecyle of a vue component
            // console.log('patientId in mounted: ' + this.patientId);
        },
        computed: {

        },
        watch: {
            //'selectedUser': function (newVal, oldVal) {
            //    if (newVal != oldVal) {
            //        let vm = this;
            //        vm.SSOEnabled = vm.selectedUser.SSO_ENABLED;
            //        vm.email = vm.selectedUser.UserName;
            //        //this.$emit("resetValidation");

            //    }
            //},
            /* 'selectedStatus': function (newVal, oldVal) {
                if (newVal != oldVal) {
                }
            } */
        },
        methods: {
            formatCurrency(inputValue: string): void {
                let numericInput: string = this[inputValue].replace(/[^0-9.]/g, '');
                numericInput = numericInput.replace(/^(\d*\.\d{0,2}|\d*)\.*\d*$/, '$1');
                if (numericInput === '') {
                    this[inputValue] = '';
                } else {
                    this[inputValue] = '$' + numericInput;
                }
            },

            async showPopup() {
                //this.resetClaims();
                this.updateTitle();
                this.openPopup = true;
                await this.GetAllFacilitiesInRegionByActiveFacID();
                await this.GetConsultClaimInfo();
                this.disableLeftTab = true;
                if(this.consultClaims.length < 2) {
                    this.disableRightTab = true;
                }
                
            },
            hidePopup() {
                this.resetClaims();
                this.resetInputFields();
                this.openPopup = false;
                this.disableDelete = true;
                this.disablePrint = true;
                this.$emit('get-calendar-events');
            },

            

            async SaveClick() {
                this.updateConsultClaimObject();
                this.consultClaims[this.index] = this.consultClaim;
                if(this.errorsFound == false){
                    await axios
                    .post("../../Common/Services/EmarClientOperations.svc/SaveConsultClaim",
                        {
                            ConsultClaims: JSON.stringify(this.consultClaims),
                        }
                    );

                    this.hidePopup();
                    this.$emit('show-alert');
                    

                }
                this.resetClaims();
                this.disableDelete = true;
                this.disablePrint = true;
                
                            
            },

            updateConsultClaimObject() {
                this.errorMessages = [];
                this.errorsFound = false;
                this.consultClaim.patID = this.thisEvent.extendedProps.patID;
                if (!this.selectedStatus) {
                    this.errorMessages.push('Please select a status');
                    this.errorsFound = true;
                }
                else
                this.consultClaim.Status = this.selectedStatus.Key;
                
                this.consultClaim.ConsultApptID = this.thisEvent.extendedProps._AppointmentID;
                this.consultClaim.ServiceFromDate = this.ServiceFromDate;
                this.consultClaim.ServiceToDate = this.ServiceToDate;
                if(!this.selectedFac) {
                    this.errorMessages.push('Please select a Facility');
                    this.errorsFound = true;
                }
                else 
                this.consultClaim.SendOutFac = this.selectedFac.Key;

                this.consultClaim.BillingProvider = this.checkEmpty(this.ProviderText);
                this.consultClaim.ClaimNumber = this.checkEmpty(this.ClaimNumberText);
                this.consultClaim.ProcedureCode = this.checkEmpty(this.ProcedureCodeText);
                this.consultClaim.DRG = this.checkEmpty(this.DRGText);
                
                this.consultClaim.ClaimAmount = this.checkForPennies(this.ClaimAmountText);
                this.consultClaim.ContractualAdjustment = this.checkForPennies(this.ContractualAdjustmentText);
                this.consultClaim.ClaimReceived = this.ClaimReceivedText;
                this.consultClaim.ClaimAdjudicated = this.checkForPennies(this.ClaimAdjudicatedText);
                this.consultClaim.Carrier = this.checkEmpty(this.CarrierText);
                this.consultClaim.MemberID = this.checkEmpty(this.MemberID);
                this.consultClaim.GroupID = this.checkEmpty(this.GroupID);
                //this.consultClaim.InsuranceType = this.checkEmpty(this.InsuranceTypeList);
                 if(!this.selectedInsurance) {
                    this.errorMessages.push('Please select a Insurance type');
                    this.errorsFound = true;
                }
                else
                this.consultClaim.InsuranceType = this.selectedInsurance.Key;
                
                this.consultClaim.ConsultRequestID = Number(this.thisEvent.id);
                this.consultClaim.AllowedAmount = this.checkForPennies(this.AllowedAmountText);
                this.consultClaim.InsurancePayment = this.checkForPennies(this.InsurancePaymentText);
                this.consultClaim.PTResp = this.checkForPennies(this.PTRespText);
                this.consultClaim.MedicaidCheck = this.MedicaidChecked

            },

            async GetAllFacilitiesInRegionByActiveFacID() {

                var vm = this;

                let response = await axios.post("../../../Common/Services/EmarClientOperations.svc/GetAllFacilitiesInRegionByActiveFacID");

                    
                vm.FacList = [];
                vm.FacList = JSON.parse(response.data.d);

            },

             async GetConsultClaimInfo() {

                const defaultDate = new Date('0001-01-01T00:00:00');
                //this.returnClaim = new Object() as ConsultClaim;
                this.consultClaims = [];
                let response = await axios.post("../../../Common/Services/EmarClientOperations.svc/GetConsultClaimInfo",
                        {
                            ConsultApptID: JSON.stringify(this.thisEvent.extendedProps._AppointmentID),
                        }
                    );

                    
                this.consultClaims = JSON.parse(response.data.d);
                if(this.consultClaims.length > 0) {
                        const selectedStatusObject = this.StatusList.find(
                        (status) => status.Key === this.consultClaims[this.index].Status
                    );
                    this.selectedStatus = selectedStatusObject
                    ? { Key: selectedStatusObject.Key, Value: selectedStatusObject.Value }
                    : null;
                    if (this.consultClaims[this.index].ServiceFromDate.getTime() === defaultDate.getTime()) {
                    
                    const today = new Date();
                    this.ServiceFromDate = today;
                    } else {
                    // Otherwise, use the existing date
                    this.ServiceFromDate =this.consultClaims[this.index].ServiceFromDate;
                    }
                    if (this.consultClaims[this.index].ServiceToDate.getTime() === defaultDate.getTime()) {
                    
                    const today = new Date();
                    this.ServiceToDate = today;
                    } else {
                    // Otherwise, use the existing date
                    this.ServiceToDate = this.consultClaims[this.index].ServiceToDate;
                    }
                    const selectedFacObject = this.FacList.find(
                        (fac) => fac.Key === this.consultClaims[this.index].SendOutFac
                    );
                    this.selectedFac = selectedFacObject
                    ? { Key: selectedFacObject.Key, Value: selectedFacObject.Value }
                    : null;
                    this.ProviderText = this.checkEmpty(this.consultClaims[this.index].BillingProvider);
                    this.ClaimNumberText = this.checkEmpty(this.consultClaims[this.index].ClaimNumber);
                    this.ProcedureCodeText = this.checkEmpty(this.consultClaims[this.index].ProcedureCode);
                    this.DRGText = this.checkEmpty(this.consultClaims[this.index].DRG);
                    this.ClaimAmountText = this.consultClaims[this.index].ClaimAmount;
                    this.ContractualAdjustmentText = this.consultClaims[this.index].ContractualAdjustment;
                    this.ClaimReceivedText = this.consultClaims[this.index].ClaimReceived;
                    this.ClaimAdjudicatedText = this.consultClaims[this.index].ClaimAdjudicated;
                    this.CarrierText = this.checkEmpty(this.consultClaims[this.index].Carrier);
                    this.MemberID = this.checkEmpty(this.consultClaims[this.index].MemberID);
                    this.GroupID = this.checkEmpty(this.consultClaims[this.index].GroupID);
                    //this.InsuranceTypeList = this.checkEmpty(this.consultClaims[this.index].InsuranceType);
                     const selectedInsuranceObject = this.InsuranceTypeList.find(
                        (insurance) => insurance.Key === this.consultClaims[this.index].InsuranceType
                    );
                    this.selectedInsurance = selectedInsuranceObject
                    ? { Key: selectedInsuranceObject.Key, Value: selectedInsuranceObject.Value }
                    : null;
                    this.consultClaim = this.consultClaims[this.index];
                    this.consultClaim.ConsultApptID = this.thisEvent.extendedProps._AppointmentID;
                    this.disableDelete = false;
                    this.disablePrint = false;
                    this.AllowedAmountText = this.consultClaims[this.index].AllowedAmount;
                    this.InsurancePaymentText = this.consultClaims[this.index].InsurancePayment;
                    this.PTRespText = this.consultClaims[this.index].PTResp;
                    this.MedicaidChecked = this.consultClaims[this.index].MedicaidCheck;
                }
                else {
                    this.disableDelete = true;
                    this.disablePrint = true;
                }
                
            },

            checkForPennies(moneyAmount) {
                if(moneyAmount === "") {
                    moneyAmount = null;
                }
                if (moneyAmount !== null && !/\.\d{1,2}$/.test(moneyAmount)) {
                    // If not, add .00 to the end
                    moneyAmount += '.00';
                }
                return moneyAmount;
            },
            checkEmpty(pString) {
                if(pString === '' || pString === "") {
                    pString = null;
                }
                return pString;
            },
            AddClaimClick() {
                this.updateConsultClaimObject();
                if(this.errorsFound == false) {
                    if(this.consultClaims.length > 0) {
                        this.consultClaims[this.index] = this.consultClaim;
                    }
                    else {
                        //if consultClaims is empty you need to push the first claim
                        this.consultClaims.push(this.consultClaim);
                    }
                    this.index =this.consultClaims.length;
                    this.consultClaim = new Object() as ConsultClaim;
                    this.consultClaims.push(this.consultClaim);
                    this.updateTitle();
                    this.resetInputFields();
                    if(this.disableLeftTab == true) {
                        this.disableLeftTab = false;
                    }
                    this.disableDelete = false;
                    this.disablePrint = false;
                    this.disableRightTab = true;
                }
                
            },
            LeftTabClick() {
                if(this.index > 0) {
                    this.updateConsultClaimObject();
                    if(this.errorsFound == false) {
                        this.consultClaims[this.index] = this.consultClaim;
                        this.index--;
                        this.updateTitle();
                        this.consultClaim = this.consultClaims[this.index];
                        this.pushConsultClaimTofields();
                        if(this.disableRightTab == true) {
                            this.disableRightTab = false;
                        }
                    }
                    
                }
                if(this.index == 0) {
                    this.disableLeftTab = true;
                }
                this.disableDelete = false;
                this.disablePrint = false;
            },
            RightTabClick() {
                if(this.index < this.consultClaims.length - 1) {
                    this.updateConsultClaimObject();
                     if(this.errorsFound == false)  {
                        this.consultClaims[this.index] = this.consultClaim;
                        this.index++;
                        this.updateTitle();
                        this.consultClaim = this.consultClaims[this.index];
                        this.pushConsultClaimTofields();
                        if(this.disableLeftTab == true) {
                            this.disableLeftTab = false;
                        }
                        
                        if(this.index == this.consultClaims.length - 1) {
                            this.disableRightTab = true;
                        }
                     }
                   
                }
                this.disableDelete = false;
                this.disablePrint = false;
            },
            SetTabs() {
                if(this.consultClaims.length <= 1) {
                    this.disableLeftTab = true;
                    this.disableRightTab = true;
                }
                if(this.consultClaims.length > 1 && this.index == 0) {
                    this.disableLeftTab = true;
                    this.disableRightTab = false;
                }
                if(this.consultClaims.length > 1 && this.index > 0) {
                    this.disableLeftTab = false;
                    if(this.index < this.consultClaims.length - 1) {
                        this.disableRightTab = false;
                    }
                }
            },
            SetDisableBtns() {
                if(this.consultClaims.length > 0) {
                    this.disableDelete = false;
                    this.disablePrint = false;
                }
                else {
                    this.disableDelete = true;
                    this.disablePrint = true;
                }
            },
            SetClaimDisplayOnDelete() {
                if(this.consultClaims.length == 0) {
                    this.resetClaims();
                    this.resetInputFields();
                    this.index = 0;
                    this.updateTitle();
                    return;
                }
                if(this.index > 0) {
                    this.index --;
                }
                this.consultClaim = this.consultClaims[this.index];
                this.pushConsultClaimTofields();
                this.updateTitle();
            },
            resetInputFields() {
                this.selectedStatus = null;
                this.selectedFac = null;
                this.ServiceToDate = new Date();
                this.ServiceFromDate = new Date();
                this.ProviderText = '';
                this.ClaimNumberText = '';
                this.ProcedureCodeText = '';
                this.DRGText = '';
                this.ClaimAmountText = '';
                this.ContractualAdjustmentText = '';
                this.ClaimReceivedText = new Date();
                this.ClaimAdjudicatedText ='';
                this.CarrierText = '';
                this.MemberID = '';
                this.GroupID = '';
                this.selectedInsurance = null;
                this.PaidText = '';
                this.AllowedAmountText = '';
                this.InsurancePaymentText = '';
                this.PTRespText = '';
                this.MedicaidChecked = false;
                
            },
            pushConsultClaimTofields() {
                const selectedStatusObject = this.StatusList.find(
                    (status) => status.Key === this.consultClaim.Status
                );
                this.selectedStatus = selectedStatusObject
                ? { Key: selectedStatusObject.Key, Value: selectedStatusObject.Value }
                : null;
                const selectedFacObject = this.FacList.find(
                    (fac) => fac.Key === this.consultClaim.SendOutFac
                );
                this.selectedFac = selectedFacObject
                ? { Key: selectedFacObject.Key, Value: selectedFacObject.Value }
                : null;
                this.ServiceToDate = this.consultClaim.ServiceToDate;
                if (this.consultClaim.ServiceToDate === undefined) {
                    this.ServiceToDate = new Date(); // Assigning current date if ServiceFromDate is undefined
                } else {
                    this.ServiceToDate = this.consultClaim.ServiceToDate;
                }
                if (this.consultClaim.ServiceFromDate === undefined) {
                    this.ServiceFromDate = new Date(); // Assigning current date if ServiceFromDate is undefined
                } else {
                    this.ServiceFromDate = this.consultClaim.ServiceFromDate;
                }
                
                
                this.ClaimAmountText = this.consultClaim.ClaimAmount === null ? "" : this.consultClaim.ClaimAmount;
                this.ContractualAdjustmentText = this.consultClaim.ContractualAdjustment === null ? "" : this.consultClaim.ContractualAdjustment;
                
                if (this.consultClaim.ClaimReceived === undefined) {
                    this.ClaimReceivedText = new Date(); // Assigning current date if ServiceFromDate is undefined
                } else {
                    this.ClaimReceivedText = this.consultClaim.ClaimReceived;
                }
                this.ClaimAdjudicatedText = this.consultClaim.ClaimAdjudicated === null ? "" : this.consultClaim.ClaimAdjudicated;
                this.ProviderText = this.consultClaim.BillingProvider;
                this.ClaimNumberText = this.consultClaim.ClaimNumber;
                this.ProcedureCodeText = this.consultClaim.ProcedureCode;
                this.DRGText = this.consultClaim.DRG;
                this.ClaimAdjudicatedText = this.consultClaim.ClaimAdjudicated;
                this.CarrierText = this.consultClaim.Carrier;
                this.MemberID = this.consultClaim.MemberID;
                this.GroupID = this.consultClaim.GroupID;
                //this.InsuranceTypeList = this.consultClaim.InsuranceType;
                const selectedInsuranceObject = this.InsuranceTypeList.find(
                    (status) => status.Key === this.consultClaim.InsuranceType
                );
                this.selectedInsurance = selectedInsuranceObject
                ? { Key: selectedInsuranceObject.Key, Value: selectedInsuranceObject.Value }
                : null;
                this.AllowedAmountText = this.consultClaim.AllowedAmount === null ? "" : this.consultClaim.AllowedAmount;
                this.InsurancePaymentText = this.consultClaim.InsurancePayment === null ? "" : this.consultClaim.InsurancePayment;
                this.PTRespText = this.consultClaim.PTResp === null ? "" : this.consultClaim.PTResp;
                this.MedicaidChecked = this.consultClaim.MedicaidCheck
                
            },
            resetClaims() {
                this.index = 0;
                this.consultClaims = [];
                this.consultClaim = new Object() as ConsultClaim;
                this.returnClaim = new Object() as ConsultClaim;
                this.disableRightTab = false;
                this.disableLeftTab = true;
            },
            async deleteClaim() {
                if(this.consultClaim.ID != 0) {
                    await axios
                    .post("../../Common/Services/EmarClientOperations.svc/DeleteConsultClaim",
                        {
                            ConsultClaimID: JSON.stringify(this.consultClaim.ID),
                        }
                    );
                }
                this.consultClaims.splice(this.index, 1);
                this.SetClaimDisplayOnDelete();
                this.SetDisableBtns();
                this.SetTabs();
            },
            updateTitle() {
                this.title = 'Consult Claim - ' + this.thisEvent.extendedProps.patName + ' Claim #' + (this.index+1);
            },
            async PrintAllClick() {
                this.showOverlay = true;
                this.disableFooterbtns();
                let response = await axios.post("../../../Common/Services/EhrTaskService.svc/GetPrintClaimsPDF",
                    {
                        ConsultApptID: JSON.stringify(this.consultClaim.ConsultApptID),
                    }
                );         
                const contentType = 'application/pdf';
                const b64Data = JSON.parse(response.data.d);
                const blob = b64toBlob(b64Data, contentType);
                var fileURL = window.URL.createObjectURL(blob);
                var fileLink = document.createElement('a');
                
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'Patient Claims EOB.pdf');
                document.body.appendChild(fileLink);
                fileLink.click();
                this.showOverlay = false;
                this.enableFooterbtns();
            },

             async PrintClick() {
                this.showOverlay = true;
                this.disableFooterbtns();
                let response = await axios.post("../../../Common/Services/EhrTaskService.svc/GetPrintSingleClaimPDF",
                    {
                        ConsultClaimID: JSON.stringify(this.consultClaim.ID),
                    }
                );         
                const contentType = 'application/pdf';
                const b64Data = JSON.parse(response.data.d);
                const blob = b64toBlob(b64Data, contentType);
                var fileURL = window.URL.createObjectURL(blob);
                var fileLink = document.createElement('a');
                
                fileLink.href = fileURL;
                fileLink.setAttribute('download', 'Patient Claim EOB.pdf');
                document.body.appendChild(fileLink);
                fileLink.click();
                this.showOverlay = false;
                this.enableFooterbtns();
            },
            disableFooterbtns () {
                this.disableDelete = true;
                this.disableFooterbtn = true;
                this.disablePrint = true;
            },
            enableFooterbtns () {
                this.disableDelete = false;
                this.disableFooterbtn = false;
                this.disablePrint = false;
            },
        }
    });
    function b64toBlob(b64Data: string, contentType='', sliceSize=512) {
        const byteCharacters = atob(b64Data);
        const byteArrays = [];

        for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            const slice = byteCharacters.slice(offset, offset + sliceSize);

            const byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
            }

            const byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }

        const blob = new Blob(byteArrays, {type: contentType});
        return blob;
    }
    export type ConsultClaimPopupRef = InstanceType<typeof ConsultClaimPopup>;
        export default ConsultClaimPopup;
